export default {
  name: 'vscroll',
  version: '1.8.0'
};
